import Lang from '~/lang'
import browser from 'browser-detect';

const detect = browser();

//check if this is Internet Explorer IE6-11
function isExplorer() {
    return typeof navigator !== 'undefined' && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent))
}
let isEdge = (detect.name === 'edge')

if (isExplorer() || (isEdge && detect.versionNumber < 83.047844)) {

    if (window.confirm(` ${Lang.get("javascript.browser.browser_incompatible_messageIe6")}`)) {
        window.open("https://www.google.com/intl/"+ Lang.locale +"/chrome/", '_blank')
    }
  /*Metro.dialog.create({
    // title: Lang.get("javascript.browser.incompatibility"),
    content: Lang.get("javascript.browser.browser_incompatible_message"),
    actions: [
      {
        caption: `<i class="fab fa-chrome"></i> Chrome`,
        cls: "js-dialog-close alert",
        onclick: function(){
          window.open("https://www.google.com/intl/"+ Lang.locale +"/chrome/", '_blank');
        }
      },
      {
        caption: `<i class="fab fa-firefox-browser"></i> Firefox`,
        cls: "js-dialog-close",
        onclick: function(){
          window.open("https://www.mozilla.org/"+ Lang.locale +"/firefox/download/thanks/", '_blank');
        }
      }
    ],
  })*/
}
